import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getPrincipalMessage } from '../Service/Api';
import LazyLoad from 'react-lazyload';

const DirectorMessage = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      setData(messages);
    };
    fetchData();
  }, []);

  const emptyArray = [
    { description: "“Educating the mind without educating the heart is no education at all.” Sacred Heart has been educating boys and girls since 1990; though much has changed over the years our mission remains the same. Sacred Heart is committed to developing students of high academic achievement, intellectual curiosity, and strong moral character. As a result, year after year Sacred Heart sends our respectful, responsible and compassionate young adults, who are well prepared to tackle the challenges that lay ahead. Since arriving at Sacred Heart in 2016, I have had the opportunity to observe this unique institution up close. I have seen its commitment to academic excellence, its dynamic student body, and incredibly committed faculty and a loving community where the students and families are proud and supportive of one another. As I walk down the hallways of the school every day, I can hear the chatter of eager minds; the shouts of excitement from the victorious athletes, the thumb of dancers feed and the sound of melodious voices harmonizing the perpetual energy, movement and enthusiasm permeate the atmosphere. Ours is a school with difference. We value creativity and innovation and strive to nurture them in our students. Sacred Heartians are groomed to become confident, articulate and enlightened young citizens ready to step into the global society with dignity, honour and integrity. Aristotle once said “Educating the mind without educating the heart is no education at all”. Even as we impart education to match the advancement in technology and globalization, we march our children ahead with Sacred Heart ethos of moral values and principles. We Endeavour constantly to instill these qualities in our children. We pride ourselves to help them grow and develop into sensitive, responsible God loving citizens of the future. May the Sacred Heart of Jesus bless us abundantly in all our endeavourers.", attachments: "director.jpg" },   
  ];

  return (
    <>
      <div className="innerslide">
        <ul className="breadcrumb">
        <li><Link to="/home"> Home</Link> </li>
          <li>About Us</li>
          <li> Director's Message</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Director's Message</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              {data?.length > 0 ? (
                data?.filter((div) => div.category === "Director").map((item, index) => (                
                  <div key={index}>
                    <div className="msgbox">
                      <LazyLoad><img src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`} alt="" className="img-fluid"/></LazyLoad>
                    </div>
                    <p>{item?.message}</p>
                    <p className="name">Sr.Sobel S.H. <span>Director</span></p>
                  </div>
                ))
              ) : (
                emptyArray.map((data, index) => (
                  <div key={index}>
                    <div className="msgbox">
                      <LazyLoad><img src={data.attachments} alt="" className="img-fluid"/></LazyLoad>
                    </div>
                    <p>{data.description}</p>
                    <p className="name">Director</p>
                  </div>
                ))
              )}
            </div>
          </div> 
        </div>
      </div>
    </>
  );
}

export default DirectorMessage;
